import connectField    from 'uniforms/connectField';
import {createElement} from 'react';

const Static = ({html, tag}) => (
    createElement(tag, {dangerouslySetInnerHTML: {__html: html}})
);

Static.defaultProps = {
    tag: 'div'
};

export default connectField(Static);



// WEBPACK FOOTER //
// ./src/components/UI/uniforms/StaticField.jsx